import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const ArrowTopLeftAngleIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M10.8284 2.34314H2.34314M2.34314 2.34314L2.34314 10.8284M2.34314 2.34314L13.6568 13.6568" stroke={color} strokeLinejoin="round" />
  </Svg>
);

ArrowTopLeftAngleIcon.displayName = 'ArrowTopLeftAngleIcon';
